<!-- <nav class="navbar header" role="navigation" aria-label="main navigation">
    <div style="text-align: center;">
        <a style="text-align: center;" href="home">
            <img class="logoimg" src="../../../assets/img/Group2.png">.org

        </a>

        <a role="button" class="navbar-burger burger" aria-label="menu" aria-expanded="false"
            data-target="navbarBasicExample">
            <span aria-hidden="true" style="color: #fff;"></span>
            <span aria-hidden="true" style="color: #fff;"></span>
            <span aria-hidden="true" style="color: #fff;"></span>
        </a>
    </div>
    <div id="navbarBasicExample" style="background-color:#47017F;" class="navbar-menu">
        <nav class="navbar-start">
            <div class="navbar-start">
                <a routerLink="/" class="navbar-item ba-headertxt">
                    Home
                </a>
                <a routerLink="resources" class="navbar-item ba-headertxt">
                    Resources
                </a>

                <a routerLink="cardgame" class="navbar-item ba-headertxt">
                    Play
                </a>
                <a class="navbar-item ba-headertxt">
                    Learning
                </a>

                <a class="navbar-item ba-headertxt">
                    Community
                </a>
                <div class="navbar-item has-dropdown is-hoverable">
                    <a class="navbar-link navbar-item ba-headertxt">
                        About
                    </a>
                    <div class="navbar-dropdown">
                        <a class="navbar-item">
                            Open Source
                        </a>
                    </div>
                </div>

            </div>
            <div class="navbar-end">
                <div class="navbar-item">
                    <div class="buttons">
                        <a (click)="registerModal()" class=" button is-rounded is-info is-inverted is-outlined">
                            <strong>Sign up/</strong><strong> <span></span> Sign in</strong>
                        </a>
                    </div>
                </div>
            </div>
        </nav>



    </div>
</nav> -->
<nav class="navbar is-fixed-top" style="display: none;" role="navigation" aria-label="main navigation"
    style="background-color: #47017F!important;">
    <div class="navbar-brand">
        <a class="navbar-item" href="home" style="padding: 0px;">
            <img class="logoimg" src="../../../assets/img/Logo@2xup.png" style="max-height: 3.25rem;">
        </a>

        <a role="button" class="navbar-burger burger" style="color: whitesmoke;" aria-label="menu" aria-expanded="false"
            data-target="navbarBasicExample">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
        </a>
    </div>

    <div id="navbarBasicExample" style="background-color: #47017F!important;" class="navbar-menu">
        <div class="navbar-start" style="flex-grow: 1; justify-content: center;">
            <a routerLink="/" class="navbar-item ba-headertxt">
                Home
            </a>
            <a routerLink="resources" class="navbar-item ba-headertxt">
                Resources
            </a>

            <a routerLink="cardgame" class="navbar-item ba-headertxt">
                Play
            </a>
            <a href="http://community.beingabundance.org/" target="_blank" class="navbar-item ba-headertxt">
                Community
            </a>
            <a href="/calender" class="navbar-item ba-headertxt">
                Events
            </a>


            <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                    About Us
                </a>
                <div class="navbar-dropdown is-boxed">
                    <a class="navbar-item" target="_blank" href="http://beingabundance.wpflight.com/">
                        Open Source
                    </a>
                    <a class="navbar-item" routerLink="/ourteam">
                        Our Team
                    </a>
                    <a class="navbar-item" routerLink="/constitution">
                        Constitution
                    </a>
                </div>
            </div>
        </div>

        <div class="navbar-end" *ngIf="!isLoggedIn">
            <div class="navbar-item">
                <div class="buttons">

                    <a (click)="registerModal()" class=" button  is-info is-inverted is-outlined">
                        <strong>Sign up / Login</strong>
                    </a>

                </div>
            </div>
        </div>
        <div class="navbar-end" *ngIf="isLoggedIn">
            <div class="navbar-item has-dropdown is-hoverable">
                <a class="navbar-link">
                    <div>
                        <a style="padding: 4px;" role="button">
                            <img style="border-radius: 50%;height: 100px;" src="../../../assets/img/user.svg"></a>
                    </div>
                </a>
                <div class="navbar-dropdown is-right" style="background: #F1FAFF;border: 1px solid lightgray;">
                    <a class="navbar-item">
                        My Profile
                    </a>
                    <hr class="navbar-divider">
                    <a class="navbar-item" (click)="logout()">
                        Log out
                    </a>
                </div>
            </div>
        </div>

    </div>
</nav>